
import './App.css';
import AppRoute from './route/route';
import { Fragment } from 'react';
import 'rsuite/dist/rsuite.min.css';
import { ServiceContextProvider } from './services/services-context';
import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

function App() {

  

  return (
    <Fragment>
      <ServiceContextProvider>
        <AppRoute />
      </ServiceContextProvider>
      
    </Fragment>
  );
}

export default App;
